import { vservice } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { ExportCheckStatusResourceModel } from '@/modules/common/table-export/models/export-resource.model'
import { ExportService } from '@/modules/common/table-export/services/export.service'
import { Data } from '@/modules/shared/models/data'

@vservice()
export class ExportCheckStatusUseCase {

  constructor(
    private readonly service: ExportService
  ) {
  }

  public remoteData = RemoteData
    .notAsked<Data<ExportCheckStatusResourceModel>>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get data(): ExportCheckStatusResourceModel {
    return this.remoteData.fold(
      () => null,
      value => value.data || null,
      value => value.data,
      (error, value) => value.data || null
    )
  }

  execute(exportExcel: string): RemoteData<Data<ExportCheckStatusResourceModel>> {
    return this.remoteData.fromPromise(
      this.service.checkExportStatus(exportExcel)
    )
  }
}
